import React, { Component } from 'react';
import $ from 'jquery';
import * as actions from '../../actions';
import {Link} from 'react-router';
import {connect} from 'react-redux';
// import './assets/css/style_web.css';
import {DropdownButton} from 'react-bootstrap';
import WebBanners from './WebBanners.js';
import {Modal, Tab,Tabs, Col, } from 'react-bootstrap';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

class WebHeaderHome extends Component{
	constructor(props){
		super(props);
		this.state={
			status: '',
			keyword: '',
		    cart_count:0,
		    aquacash:'',
		    bookings:'',
		    noty_count:'',
		    menuItems:[],

		    pro_pic:baseAssets+'images/pro_pics/profile_pic.png',
		}
		this.getMenuItems=this.getMenuItems.bind(this);
		this.onFocus=this.onFocus.bind(this);
		this.getCartCount=this.getCartCount.bind(this);
		this.getProfile =this.getProfile.bind(this);
	}



	componentDidMount()
	{
		this.getMenuItems();
		this.getCartCount();
	    this.getProfile();
	}
    getProfile()
    {
    
      if(!localStorage.user_id && !localStorage.token)
      {
      	 // this.setState({pro_pic:'profile_pic.png'});
      }
      else
      {
      	if(localStorage.user_id)
    	{
    		var uid =localStorage.user_id;
    	}
    	else
    	{
    		uid=0;
    	}
      	var data1={from:'desktop_web',uid:uid,token: localStorage.getItem('token'),device_id:localStorage.getItem('push_device_id')};
        var data2 =JSON.stringify(data1);
	      $.ajax({
	        url:baseUrl+'myprofile',
	        method:'POST',
	        data:{req:data2},
	        dataType:'JSON',
	        success:function(data)
	        {
	           if(data.msg === 'success')
	           {
	           	  this.setState({pro_pic:baseAssets+'images/pro_pics/'+data.details[0].pro_pic,});
	           }
	            if(data.status==='error' && data.message ==='Token mismatch')
	            {
	           		localStorage.removeItem('user_id');
	           		localStorage.removeItem('token');
	           		window.location.reload();
	            }
	        }.bind(this),
	        error:function(err)
	        {

	        } 
	      });
     }
    }

	logout()
	{
	    localStorage.clear();
	    window.location.reload();
	}
	getCartCount()
  	{
	    if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
	    var data1={from:'desktop_web',id:uid,token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
            method: 'POST',
            url: baseUrl+'cart_count',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
              if(data.status==='error' && data.message==='Token mismatch')
              {
                this.props.tokenCheck();
              }
              this.setState({
                  cart_count:data.cart_count,
              });
            }.bind(this),
            error: function(err)
            {
            
            }
        });
  	}
	onFocus(event)
	{
	    this.setState({
	        status: 'foucs',
	        keyword: event.target.value
	    })
	}
	getMenuItems()
	{
	    var data1={from:'desktop_web',};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method:'POST',
	        dataType:'json',
	        url:baseUrl+'browse_categories',
	        data:{req:data2},
	        success:function(data)
	        {
	          if(data.status==='success')
	          {
	            this.setState({
	                menuItems:data.categories,
	            });
	          }
	        }.bind(this),
	        error:function(err)
	        {

	        }
	    });
	}
	onChangeKey(event)
	{
	    if(event.target.value.length > 2)
	    {
	      this.props.search_products(event.target.value);
	    }
	    else if(event.target.value.length === 0)
	    {
	      this.props.search_products('');    
	    }
	    this.setState({
	        keyword: event.target.value
	    });
	}
  	onBlur()
  	{  
	    this.setState({
	      status: 'unfocus'
	    })
	}
  	resetKey()
  	{
	    this.props.search_products('');
	      this.setState({
	          keyword: ''
	      });
	}
	render()
	{
		  const params = {
		    paginationClickable: true,
		    spaceBetween: 10,
		    slidesPerView: 4.5
		  }  		
		$(document).on('mouseup',function (e)
		{
		    var container = $('.ad_search');
		    var container_sub = $('.res');

		    if (!container.is(e.target) // if the target of the click isn't the container...
		        && container.has(e.target).length === 0) // ... nor a descendant of the container
		    {
		        container_sub.hide();
		    }else{
		    	container_sub.show();
		    }
		});
		var menuItems=this.state.menuItems.map(function(data,index){
		    return(
		        <li id={index} onClick={()=>{location.reload();}}><Link to={data.redirect_url}>{data.dtype}</Link></li>
		    );
		})
		if(this.props.brands.length > 0 ){ var brands = (<h5 className="brand_hdr">Brands</h5>)} 
		if(this.props.products.length > 0 ){ var products = (<span><div className="clr"></div><h5 className="brand_hdr">Products</h5></span>)}  
		  
		if(this.props.categories)
		{
		      if(this.props.categories.length > 0){
		        var categories = (<h5 className="brand_hdr">Categories</h5>)  
		      }
		}
	  	var that = this;
  		var brands_list=this.props.brands.map(function(brand,index){
        return(
           <Link to={"/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_brand_name+"/"+brand.id +"/"+brand.type+"/"+brand.dtype} onClick={()=>{that.saveSearch(localStorage.user_id,brand.id,3)}}>
            <Col md={12} sm={12} xs={12} className="srh_list_item">
              <Col md={2} sm={2} xs={2} className="">
                <img src={brand.logo !=='' && brand.logo !== null ? baseAssets+'images/brand_icons/'+brand.logo : baseAssets+'icons/web_icons/noImage.png'} role="presentation" alt=" " width='30px'/>
              </Col>
              <Col md={10} sm={10} xs={10} className="">
                <div className="srh_cnt_all">{brand.category_name}</div>
              </Col>
              <Col md={1} sm={1} xs={1} className="srh_deal_cnt">
                <i>{brand.dealcount}</i>
              </Col>                            
            </Col>
          </Link>  
         )
      	 }); 
		if(this.props.categories)
		{
		    if(this.props.categories.length > 0){
		    	var categories_list=this.props.categories.map(function(category,index){
			    	return(
			            <li key={index} onClick={()=>{location.reload();}}>
			              <Link style={{textDecoration: 'none'}} className="brand_tlt" to={"/web/pdeals/"+category.url_dtype_name+"/"+category.url_cat_name+"/"+category.id+"/"+category.type+"/"+category.dtype} >
			                <img className="" alt="" src={'https://aquadeals.in/admin/assets/images/icons/'+category.logo} width="30px;"/>
			                  <span>
			                    {category.category_name}
			                  </span>
			              </Link>
			            </li>
			        )
	            }) ;  
		    }
		}
		  var that=this;
		  var product_list=this.props.products.map(function(product,index){
		      return(
		          <Link to={product.dealcount > 1 ? "/web/subdeals/"+product.url_dtype_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.id+"/type/"+product.dtype : "/pdetails/"+product.url_dtype_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.id+"/"+product.deal_id} onClick={()=>{that.saveSearch(localStorage.user_id,product.id,1)}}>
		            <Col md={12} sm={12} xs={12} className="srh_list_item">
		              <Col md={2} sm={2} xs={2} className="">
		                  <img src={product.logo !=='' && product.logo!== null ? baseAssets+'images/product_imgs/thumbnails/'+product.logo : baseAssets+'icons/web_icons/noImage.png'} alt=" " width='30px'/>
		              </Col>
		              <Col md={10} sm={10} xs={10} className="">
		                <div className="srh_cnt_all">{product.category_name}</div>
		              </Col>
		              <Col md={1} sm={1} xs={1} className="srh_deal_cnt">
		                <i>{product.dealcount}</i>
		              </Col>                            
		            </Col>
		          </Link>              
		         )

		       }) ; 

       	var aut_status = '';
		if(localStorage.token)
		{
		   aut_status = <a className="cursor" onClick={this.logout.bind(this)}>LOGOUT</a>;
		}
		else
		{
		   aut_status = <Link to="/web/login">LOGIN</Link>;
		}

    if(this.props.recent_search.length > 3)
    {
        var recent_search=this.props.recent_search.map(function(item,index){
           
            var data=<div className="recent_search_list">
                        {item.type ==="product" ? <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>       
                        <Link to={item.type === "product" && item.dealcount > 1  ? "/web/subdeals/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id : "/pdetails/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id+"/"+item.deal_id}>                                             
                            <div className="recent_search_thumbnail">
                            <img src={item.logo !==null && item.logo!=='' ? baseAssets+'images/product_imgs/'+item.logo : baseAssets+'icons/web_icons/noImage.png'}  alt="" width='40px'/>
                            </div>
                            <h4>{item.category_name}</h4>                            
                        </Link>                        
                      </div> : ''}
                        
                        {item.type === 'brand' ? <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>                            
                        <Link to={"/web/pdeals/"+item.url_dtype_name+"/"+item.url_name+"/"+item.id+"/"+item.type+"/"+item.dtype}>                         
                            <div className="recent_search_thumbnail">                        
                              <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/brand_icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                          
                             </div> 
                            <h4>{item.category_name}</h4> 
                            </Link></div> : ''}

                        {item.type==='Pcategory' ? <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>                        
                        <Link to={'/pdeals/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.id+'/Pcategory/'+item.dtype}>                             
                          <div className="recent_search_thumbnail">                          
                          <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                                               
                          </div>
                          <h4>{item.category_name}</h4> 
                        </Link></div> : ''}
                    </div>
            return(data);
          }.bind(this));

    }
    else if(this.props.recent_search.length < 4 && this.props.recent_search.length != 0){
        var recent_search=this.props.recent_search.map(function(item,index){   
            var data=
                        <li className="recent_search_list">{item.type ==="product" ? <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>
                        <Link to={item.type === "product" && item.dealcount > 1  ? "/web/subdeals/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id : "/pdetails/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id+"/"+item.deal_id}>
                            <div className="recent_search_thumbnail">
                            <img src={item.logo !==null && item.logo!=='' ? baseAssets+'images/product_imgs/'+item.logo : baseAssets+'icons/web_icons/noImage.png'}  alt="" width='40px'/>                            
                            </div>
                            <h4>{item.category_name}</h4>                            
                        </Link>
                      </div> : ''}</li>
                        
                        {item.type === 'brand' ? <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>
                        <Link to={"/web/pdeals/"+item.url_dtype_name+"/"+item.url_name+"/"+item.id+"/"+item.type+"/"+item.dtype}>
                            <div className="recent_search_thumbnail">                        
                              <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/brand_icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                               
                             </div> 
                            <h4>{item.category_name}</h4> 
                            </Link></div> : ''}

                        {item.type==='Pcategory' ? <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>
                        <Link to={'/pdeals/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.id+'/Pcategory/'+item.dtype}>
                          <div className="recent_search_thumbnail">                          
                          <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                                                    
                          </div>
                          <h4>{item.category_name}</h4> 
                        </Link></div> : ''}
            return(data);
          }.bind(this));
    }
    else
    {
        recent_search='';
    }

		return(
			<div className="HomePage">
				{/* header start */}
				<header>
					
					<div className="clr"></div>
					<nav className="navbar navbar-default">
						<div className="container-fluid">
						    {/* Brand and toggle get grouped for better mobile display */}
						    <div className="navbar-header">
						      <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
						        <span className="sr-only">Toggle navigation</span>
						        <span className="icon-bar"></span>
						        <span className="icon-bar"></span>
						        <span className="icon-bar"></span>
						      </button>
						      <a className="navbar-brand ad_logo"><img src={baseAssets+'images/web_imgs/logo.png'} alt="AquaDeals" /><span>#HappyFarming</span></a>
						      <div className="clr"> &nbsp;</div>
						    </div>

				    		{/* Collect the nav links, forms, and other content for toggling */}
						    <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
								<form className="navbar-form navbar-left ad_search">
							      	<div className="dropdown ad_cat_drop">
									  	<DropdownButton title="All" id="drp_btn">
                                            {menuItems}
                                            <li id="5"><a href="http://blog.aqua.deals" target="_blank" >Blog</a></li>
                                        </DropdownButton>
									</div>
									{/* Search box starts here */}
						        	<div className="form-group">
                                      	<input type="text" ref="keyword" onChange={this.onChangeKey.bind(this)} onFocus={ this.onFocus.bind(this) }  onBlur={ this.onBlur.bind(this) } value={this.state.keyword} className="form-control" placeholder="Search for Aquaculture products, brands and more" />
                                    </div>
                                	<div className="res ressrch_box" style={{maxHeight: 400+'px',position: 'absolute',  left: 0,overflowX: 'hidden',margin:0+' auto',textDecoration: 'none',top: 45+'px', display: 'none',zindex: 9999}}>
                                        <div>
                                        	{brands}
                                        </div>
                                        <ul style={{paddingLeft : 15+'px'}}>
                                            {brands_list}
                                        </ul>
                                        <div>{products}</div>
                                        <ul style={{paddingLeft : 15+'px'}}>
                                            {product_list}
                                        </ul>
                                        <div>{categories}</div>
                                        <ul style={{paddingLeft : 15+'px'}}>
                                          	{categories_list}
                                        </ul> 
            {recent_search}
            {this.props.recent_search.length > 0 ? <div className="recent_search_blk"><div><h2>Recent Searches</h2></div>
                {this.props.recent_search.length > 3 ?
                <Swiper {...params} key={recent_search.length}>
                  {recent_search}
                </Swiper> : <div><ul className="recent_search_ul">{recent_search}</ul></div>
                }
                
            </div> : ''}                                                       
	                                </div>
	                                {/*Search box ends */}
							        <span className="btn btn-default ad_srch_btn"><i className="glyphicon glyphicon-search"></i></span>
						      	</form>
							    <ul className="nav navbar-nav navbar-right ad_nav_rgt">
							        <li className="ad_cart"><a href="/web/mycart"><img src={baseAssets+'images_web/cart_icon.png'} alt=" " /></a>{this.state.cart_count > 0 ? <i>{this.state.cart_count}</i> : ''}</li>
							        <li className="dropdown log_blk web_nav_menu">
							          	<DropdownButton className="" noCaret id="drp_btn1" title={<i><span className="web_pro_icon"><img src={this.state.pro_pic} alt=" " className="webpro_img"/></span><span className="glyphicon glyphicon-option-vertical glyph_dots"></span></i>} >
											<li><Link to={'/web/myaquacash'} title="My AquaCash">My Aquacash{this.state.aquacash ? <span className="nav_menu_right">&#8377;{this.state.aquacash}</span>: ''}</Link></li>
                                            <li><Link to={'/web/myorders'} title="My Orders">My Orders{this.state.bookings ? <span className="">{this.state.bookings}</span> : ''}</Link></li>
                                            <li><Link to={'/web/wishlist'} title="Wishlist">Wishlist</Link></li>
                                            {/*<li><Link to={'/web/mycart'} title="My Cart">My Cart {this.state.cart_count >0 ? <span className="">{this.state.cart_count}</span>: ''}</Link></li>*/}
                                            {/*{this.state.smart_cart_flag===1 ? <li><Link to={'/web/smartcart'} title="Smart Cart"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/cart_icon.png'} alt=""/></i>Smart Cart</Link></li> : ''}*/}
                                            <li><Link to={"/web/profile"} title="My Profile">My Profile</Link></li>
                                            <li><Link to={'/web/notifications'} title="Notifications">Notifications {this.state.noty_count > 0 ? <span className="nav_menu_right">{this.state.noty_count}</span> : ''}</Link></li>
                                            <li><Link to={'/web/offerszone'} title="Offers Zone">Offers Zone</Link></li>
                                            <li><Link to={'/web/share_earn'} title="Share & Earn">Share & Earn</Link></li>
                                            <li><Link to={'/web/customer_care'} title="Customer Care">Customer Support</Link></li>
                                            <li role="separator" className="divider"></li>
                                            <li>{aut_status}</li>

                                        </DropdownButton>
                                    </li>
							    </ul>
						    </div>{/* /.navbar-collapse */}
						</div>{/* /.container-fluid */}
					</nav>
					{/* sub nav start */}
					<div className="sub_nav">
						<div className="container-fluid">
						    <ul>
							    <li><Link to={'/web/downloads'} title="Download App">Download app</Link></li>
							    <li><Link to={'/web/customer_care'} title="24x7 Customer Support">24x7 Customer Support</Link></li>
							    <li><Link to={'/web/advertise-with-us'} title="Advertise with us">Advertise with us</Link></li>
							    <li><Link to={'/web/enquire_now/partner/support/sid/did'} title="Sell on AquaDeals">Sell on AquaDeals</Link></li>
							    <li><Link to="/web/aboutus" title="About Us">About Us</Link></li>
	                            <li><a href="http://blog.aqua.deals" title="AquaDeals Blog" target="_blank">Blog</a></li>
						   </ul>
						</div>
					</div>
					{/* sub nav end */}
				</header>
				{/*  header end */}
				<div className="fetrs_slid">
					{/* featurs start */}
					<div className="ad_featurs">
						<ul>
						  <li className="col-md-4 col-sm-4"><i><img src={baseAssets+'images_web/languages_icon.png'} alt=" " /></i><span>9 Languages support</span></li>
						  <li className="col-md-4 col-sm-4"><i><img src={baseAssets+'images_web/buyer_protection.png'} alt=" " /></i><span>100% Buyer protection</span></li>
						  <li className="col-md-4 col-sm-4"><i><img src={baseAssets+'images_web/customer_care.png'} alt=" "/></i><span>24/7 Customer service</span></li>
						</ul>
					</div>
					{/* featurs end */}
					<h1 className="about_title">Shop the best deals on all Aquaculture products &amp; brands online</h1>
					<WebBanners />
				</div>
			</div>
		);
	}
}

function mapStateToProps(state){
  return {
  		search:state.posts.search,
        brands:state.posts.brands,
        products:state.posts.products,
        trendings:state.posts.trendings,
        categories:state.posts.categories,
        isLoading:state.posts.isLoading,
        recent_search:state.posts.recent_search,                
	};
}

export default connect(mapStateToProps,actions)(WebHeaderHome);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/WebHeaderHome.js
 **/